import React from 'react';
import { Typography } from 'fronton-react';
import { StmProps } from '../types';
import { labelText, StmTextContainer } from './styles';

export type StmTextProps = Omit<StmProps, 'logoLink'>;

export const StmText: React.FC<StmTextProps> = ({ label, description, link }) => (
  <StmTextContainer>
    <a href={link}>
      <Typography variant="m" size="subtitle" color="text-primary" className={labelText}>
        {label}
      </Typography>
      <Typography variant="caption" color="text-minor">
        {description}
      </Typography>
    </a>
  </StmTextContainer>
);
